// extracted by mini-css-extract-plugin
export default {"clLinks":"dashboard_clLinks__ziyGO","dangerHover":"dashboard_dangerHover__XxWXc"};